// extracted by mini-css-extract-plugin
module.exports = {"section8":"____________Desktop3_section8__mj6Fs"};